// Module
var code = `<iframe ng-src="{{ \$ctrl.frameUrl }}" width="100%" height="100%" scrolling="auto" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" style="margin-top:1%;margin-bottom:1.35%"></iframe>`;
// Exports
module.exports = code;